import type { TrustedContact } from '@fruitful/investment-management';

import { requestBuilder } from '../../http/RequestBuilder';

interface GetTrustedContactParams {
    userId: string;
}

const useGetTrustedContact = requestBuilder.query<
    TrustedContact | null,
    GetTrustedContactParams
>({
    endpoint: ({ userId }) => `/api/user/${userId}/trusted-contacts`,
    queryKey: ({ userId }) => `getTrustedContact-${userId}`,
});

export default useGetTrustedContact;
